module.exports = __webpack_public_path__ + "static/media/ai.a7b96a47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ai.png
// module id = 1779
// module chunks = 0